import { ErrorHandler, NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { AppComponent } from './app.component';
import { AppRoutingModule } from './app-routing.module';
import { AutofacetsInfrastructureModule } from 'projects/autofacets-infrastructure/src/app/app.module';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbDropdownModule } from '@ng-bootstrap/ng-bootstrap';
import { HttpClientModule } from '@angular/common/http';
import { AuthGuardService } from 'projects/autofacets-infrastructure/src/Autofacets.Infrastructure.Security/Auth-Guard/auth-guard.service';
import { ErrorInterceptor } from 'projects/autofacets-infrastructure/src/Autofacets.Infrastructure.Utility/Interceptor/error.interceptor';
import { ToastrModule } from 'ngx-toastr';

@NgModule({
  declarations: [
    AppComponent
  ],
  imports: [
    BrowserModule,
    BrowserAnimationsModule,
    AppRoutingModule,
    NgbDropdownModule,
    HttpClientModule,
    ToastrModule.forRoot(),
    AutofacetsInfrastructureModule.forRoot(),
  ],
  providers: [
    { provide: ErrorHandler, useClass: ErrorInterceptor },
    AuthGuardService
  ],
  bootstrap: [AppComponent]

})
export class AppModule { }
